
import React from 'react';
import StatusBadge from '../StatusBadge';
import { cn } from "@/lib/utils";
import { BusinessStatus } from '@/types/schema/commonSchema'; // Keep BusinessStatus if it's aligned
import { BusinessRole } from '@/schemas/business'; // Import BusinessRole from Zod schemas
import { FEATURE_FLAGS } from '@/config/featureFlag';

interface BusinessCardMetadataProps {
  status: BusinessStatus;
  memberRole: BusinessRole; // Changed type to Zod's BusinessRole
  businessId: string;
  isMobile: boolean;
  isGridView: boolean;
}

const BusinessCardMetadata: React.FC<BusinessCardMetadataProps> = ({
  status,
  memberRole,
  businessId,
  isMobile,
  isGridView
}) => {
  return (
    <div className={cn(
      "flex items-center gap-1.5",
      isMobile && "flex-row justify-between w-full",
      isGridView && "flex-row justify-between w-full mt-2"
    )}>
      <div className="bg-gray-50 py-0.5 px-2.5 rounded-sm text-sm text-gray-700">
        {memberRole}
      </div>

      {FEATURE_FLAGS.BUSINESS_STATUS && (
        <StatusBadge 
          status={status} 
          showDropdown={true}
          businessId={businessId}
        />
      )}
    </div>
  );
};

export default BusinessCardMetadata;
